export default "__VITE_ASSET__VZmHipR1__"